import React from 'react';
import contact from '../assets/images/contact.webp';
import { FaArrowRight, FaEnvelope, FaPhone } from 'react-icons/fa';

const GetInTouch = ({ scrollToContact }) => {
  return (
    <div className="mt-10 py-20 px-6 lg:px-16 bg-[#f8f8f8]">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10">
        
        {/* Image Section */}
        <div className="relative w-full lg:w-1/2">
          <img
            src={contact}
            alt="Contact"
            className="rounded-lg shadow-lg object-cover h-[500px] w-[550px]"
          />
        </div>
        {/* Text Section */}
        <div className="text-gray-600 w-full lg:w-1/2">
          <p
            style={{ letterSpacing: "0.15rem", lineHeight: "1.25rem" }}
            className="uppercase text-sm md:text-base text-gray-600 mb-4 font-bold text-start"
          >
            Reach Out & Join Our Learning Community
          </p>

          <h2 className="text-start text-5xl font-bold font-poppins mb-6 leading-tight">
            Get a Free Consultation and Explore Courses that Match Your Goals
          </h2>

          <div className="mb-6 text-start text-gray-700 space-y-3 text-lg">
  {/* Email */}
  <p className="flex items-center gap-4">
    <FaEnvelope className="text-pink-600 text-2xl" />
    <a href="mailto:Sarvagystech@gmail.com" className="text-gray-600">
    Sarvagystech@gmail.com
    </a>
  </p>

  {/* Phone 1 */}
  <p className="flex items-center gap-4">
    <FaPhone className="text-pink-600 text-2xl" />
    <a href="tel:+919876543210" className="text-gray-600">
      +91 98765 43210
    </a>
  </p>

  {/* Phone 2 */}
  <p className="flex items-center gap-4">
    <FaPhone className="text-pink-600 text-2xl" />
    <a href="tel:+918765432109" className="text-gray-600">
      +91 87654 32109
    </a>
  </p>
</div>


          <button
            onClick={scrollToContact}
            className="mt-6 bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 text-white font-bold px-6 py-3 rounded-full inline-flex items-center float-start"
          >
            Explore Courses & Enroll Today <FaArrowRight className="ml-2" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default GetInTouch;
